/* Shoevendor: levertijd per paar, eerlijk tot op de dag.

   1. Tekst. Een maat uit eigen voorraad draagt het metafield "Vandaag besteld,
      morgen in huis". Dat klopt op werkdagen voor 17:00, niet op vrijdagavond
      of in het weekend. Dit script zet in elk element met .levertijd-eigen
      (productpagina, winkelwagen, productkaarten) de echte dag: "Voor 17:00
      besteld, morgen in huis", "Voor 17:00 besteld, maandag in huis" of "Nu
      besteld, dinsdag in huis". De tijd is die van Amsterdam, niet die van de
      bezoeker. Op feestdagen (Nieuwjaar, Tweede Paasdag, Koningsdag,
      Hemelvaart, Tweede Pinksterdag, beide Kerstdagen) verstuurt en bezorgt
      DPD niet; die tellen niet als werkdag. Pasen wordt uitgerekend, dus dit
      werkt elk jaar. Dezelfde regels staan in de bedanktpagina-app
      (checkout/shoevendor-checkout/.../levering.js) en de orderbevestiging.

   2. Eigenschap. Bij "In winkelwagen" krijgt de regel de eigenschap
      Levertijd: "1 werkdag" of "3-5 werkdagen". Die staat in de checkout onder
      het paar, op de order, in de bevestigingsmail en op de pakbon, en de
      bedankpagina leest hem. Welke maat uit eigen voorraad komt, staat per
      formulier in een JSON-blok (.sv-levertijd-map) dat main-product.liquid
      meegeeft. De winkelwagen toont de eigenschap niet: daar staat al het
      levertijdlabel.

   Gemengde bestelling: alles gaat samen in een pakket, dus dan geldt 3-5
   werkdagen voor alles. Dat zegt de bedankpagina; hier gaat het per paar. */
(function () {
  var GRENS = 17; // uur, op werkdagen
  var DAGEN = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

  function nuInAmsterdam(moment) {
    var delen = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(moment || new Date()).forEach(function (d) { delen[d.type] = d.value; });
    return {
      dag: new Date(Date.UTC(+delen.year, +delen.month - 1, +delen.day)),
      uur: +delen.hour
    };
  }

  // Paaszondag (Gregoriaans, anonieme methode), als UTC-tijdstip.
  function pasen(j) {
    var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var n = h + l - 7 * m + 114;
    return Date.UTC(j, Math.floor(n / 31) - 1, (n % 31) + 1);
  }
  function feestdag(d) {
    var j = d.getUTCFullYear(), DAG = 86400000, p = pasen(j);
    var koning = Date.UTC(j, 3, 27);
    if (new Date(koning).getUTCDay() === 0) koning -= DAG; // op zondag: zaterdag ervoor
    return [Date.UTC(j, 0, 1), p + DAG, koning, p + 39 * DAG, p + 50 * DAG, Date.UTC(j, 11, 25), Date.UTC(j, 11, 26)]
      .indexOf(d.getTime()) !== -1;
  }
  function werkdag(d) { var w = d.getUTCDay(); return w >= 1 && w <= 5 && !feestdag(d); }
  function volgendeWerkdag(d) {
    var n = new Date(d.getTime());
    do { n.setUTCDate(n.getUTCDate() + 1); } while (!werkdag(n));
    return n;
  }

  function belofte(moment) {
    var nu = nuInAmsterdam(moment);
    var vandaagWeg = werkdag(nu.dag) && nu.uur < GRENS;
    var verzend = vandaagWeg ? nu.dag : volgendeWerkdag(nu.dag);
    var bezorg = volgendeWerkdag(verzend);
    var verschil = Math.round((bezorg - nu.dag) / 86400000);
    var wanneer = verschil === 1 ? 'morgen' : DAGEN[bezorg.getUTCDay()];
    return {
      wanneer: wanneer,
      zin: (vandaagWeg ? 'Voor 17:00 besteld, ' : 'Nu besteld, ') + wanneer + ' in huis'
    };
  }

  var VOLZIN = /vandaag besteld,\s*morgen in huis/i;
  var KORT = /morgen in huis/i;

  function herschrijf(el, b) {
    if (el.getAttribute('data-sv-dag') === b.zin) return;
    var loper = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var knoop;
    while ((knoop = loper.nextNode())) {
      var t = knoop.nodeValue;
      if (VOLZIN.test(t)) knoop.nodeValue = t.replace(VOLZIN, b.zin);
      else if (KORT.test(t)) knoop.nodeValue = t.replace(KORT, b.wanneer + ' in huis');
    }
    el.setAttribute('data-sv-dag', b.zin);
  }

  function werkTekstBij(root) {
    var b = belofte();
    (root || document).querySelectorAll('.levertijd-eigen').forEach(function (el) { herschrijf(el, b); });
  }

  // Eigenschap op het formulier: waarde volgt de gekozen maat.
  function zetEigenschap(form) {
    var kaart = form.querySelector('.sv-levertijd-map');
    var veld = form.querySelector('.sv-levertijd-veld');
    var id = form.querySelector('[name="id"]');
    if (!kaart || !veld || !id) return;
    var eigen;
    try { eigen = JSON.parse(kaart.textContent); } catch (e) { return; }
    if (!(id.value in eigen)) { veld.disabled = true; return; }
    veld.value = eigen[id.value] ? '1 werkdag' : '3-5 werkdagen';
    veld.disabled = false;
  }

  function alleFormulieren() {
    document.querySelectorAll('form').forEach(function (f) {
      if (f.querySelector('.sv-levertijd-map')) zetEigenschap(f);
    });
  }

  // Vlak voor het versturen, voordat het thema FormData bouwt (capture-fase).
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.sv-levertijd-map')) zetEigenschap(e.target);
  }, true);

  // Na een maatwissel zet het thema het verborgen id-veld; daarna bijwerken,
  // zodat ook de snelle knop (Kopen met Shop) de goede waarde meestuurt.
  document.addEventListener('change', function () { setTimeout(alleFormulieren, 60); }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.f8pr-variant-selection, [data-template] .check, .f8pr-variants')) setTimeout(alleFormulieren, 60);
  }, true);

  function start() {
    werkTekstBij();
    alleFormulieren();
    new MutationObserver(function (lijst) {
      for (var i = 0; i < lijst.length; i++) {
        if (lijst[i].addedNodes.length) { werkTekstBij(); alleFormulieren(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Voor controle in de console: svLevertijd.belofte(new Date('2026-12-24T10:00:00+01:00'))
  window.svLevertijd = { belofte: belofte };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
